import { render, staticRenderFns } from "./AppV3SettingsItem.vue?vue&type=template&id=38e0d663&scoped=true"
import script from "./AppV3SettingsItem.vue?vue&type=script&lang=js"
export * from "./AppV3SettingsItem.vue?vue&type=script&lang=js"
import style0 from "./AppV3SettingsItem.vue?vue&type=style&index=0&id=38e0d663&prod&scoped=true&lang=css"
import style1 from "./AppV3SettingsItem.vue?vue&type=style&index=1&id=38e0d663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0d663",
  null
  
)

export default component.exports